module.exports = __webpack_public_path__ + "img/close_icon.db603e0c.svg";